import "./Footer.css";
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { useTranslation } from 'react-i18next';
import logo from "../../images/logo.png";

export const Footer = () => {
    const currentYear = new Date().getFullYear();
    const { t } = useTranslation();

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <footer className="site-footer">
            <div className="container">
                <div className="footer-top">
                    <div className="footer-brand">
                        <button className="footer-logo" onClick={scrollToTop}>
                            <img src={logo} alt="Fibox" />
                        </button>
                        <p className="footer-description">{t('footerDesc')}</p>
                    </div>
                    <div className="footer-social">
                        <p className="footer-social-label">{t("footerSocialNetworks")}</p>
                        <div className="footer-social-icons">
                            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon-link" aria-label="Instagram">
                                <FontAwesomeIcon icon={faInstagram} />
                            </a>
                            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon-link" aria-label="Facebook">
                                <FontAwesomeIcon icon={faFacebook} />
                            </a>
                            <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon-link" aria-label="LinkedIn">
                                <FontAwesomeIcon icon={faLinkedin} />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>© {currentYear} Fibox. {t('footerRights')}</p>
                    <p className="footer-made-in">{t('footerMadeIn')}</p>
                </div>
            </div>
        </footer>
    );
};
